import { RouterState }            from "connected-react-router";
import React                      from 'react';
import { useSelector }            from "react-redux";
import { ApplicationState }       from "../../../store";
import { LayoutState }            from "../../../store/layouts/types";
import { SettingsState }          from "../../../store/settings/types";
import { Routes }                 from '../../../types';
import AboutComponent             from "../../about/AboutComponent";
import AlertsHandleEventComponent from "../../alerts/AlertsHandleEventComponent";
import HelpComponent              from "../../help/HelpComponent";
import { IconComponent }          from "../../reusable/simpleComponents";

import SettingsComponent from "../../settings/SettingsComponent";

import {
  HelpUIComponent,
  LogoutUIComponent,
  SettingsUIComponent
}                                      from "../../ui";
import AcknowledgeUIEventIconComponent from "../../ui/AcknowledgeUIEventIconComponent";

// TODO
// Check why center menu is shifter on alerts page

const RightsideUIWrapperComponent = () => {
  const {settingsIsShowed} = useSelector<ApplicationState, SettingsState>(state => state.settings);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {acknowledgeFormIsOpened, helpTableOpened, aboutTableOpened} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const isAlerts = location.pathname === Routes.alerts;

  return (
    <div className='flex'>
      {isAlerts &&
      <>
        <AcknowledgeUIEventIconComponent/>
        {
          acknowledgeFormIsOpened && <AlertsHandleEventComponent/>
        }
      </>
      }

      <div>
        <IconComponent classValue={'help-icon icon op-0'}/>
      </div>
      <div>
        <IconComponent classValue={'help-icon icon op-0'}/>
      </div>
      <div>
        <IconComponent classValue={'help-icon icon op-0'}/>
      </div>
      <div className='pos-rel'>
        {settingsIsShowed && <SettingsComponent/>}
        <SettingsUIComponent/>
      </div>
      <div>
        {helpTableOpened && <HelpComponent/>}
        {aboutTableOpened && <AboutComponent/>}
        <HelpUIComponent/>
      </div>
      <div>
        <LogoutUIComponent/>
      </div>
    </div>
  )
};

export default RightsideUIWrapperComponent